import { useDroppable, UniqueIdentifier } from '@dnd-kit/core'

interface DropZoneProps {
  id: UniqueIdentifier
  data?: Record<string, any>
  children: React.ReactNode
}

export const DropZone = ({ id, data, children }: DropZoneProps) => {
  const { setNodeRef } = useDroppable({
    id,
    data,
  })

  return (
    <div ref={setNodeRef} style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 5 }}>
      {children}
    </div>
  )
}

interface DropZoneWithOverProps {
  id: UniqueIdentifier
  data?: Record<string, any>
  children: (({ isOver }: { isOver: boolean }) => React.ReactNode) | null
}

export const DropZoneWithOver = ({ id, data, children }: DropZoneWithOverProps) => {
  const { setNodeRef, isOver } = useDroppable({
    id,
    data,
  })

  return (
    <div ref={setNodeRef} style={{ width: '100%', height: '100%' }}>
      {children?.({ isOver })}
    </div>
  )
}
